function linear(t) {
  return t;
}

module.exports = linear;